// extracted by mini-css-extract-plugin
export default {"disabled":"CustomLink_disabled__5kniA"};